const downloads = {
  title: "Downloads",
  gamOnline: "GAM Online",
  reminderTitle: "Download GAM Command Center",
  reminderSubtitle: "Access faster from any device",
  website: "Mobile Website",
  desktop: "Desktop App",
  android: "Android",
  iphone: "iPhone",
  later: "Later",
} as const;
export default downloads;
